<template>
    <div class="section" ref="skillContainer">
        <div class="columns is-centered" @click="startCounts()">
            <div class="column is-center level-center" v-for="(skill, index) in skills" :key="index">
                <div class="skill">
                   <span>
                        <h6 class="subtitle is-5">{{ skill.name }}</h6>
                        <countTo :ref="skill.name" :startVal='0' :endVal='skill.count' suffix="%" :autoplay="false" :duration='2000'></countTo>
                   </span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import countTo from 'vue-count-to';
    export default {
        name : 'Skills',
        props : {
            scrolling : {
                default : {}
            }
        },
        data  : () => ({
            skills : [
                {name : 'Laravel', count : 100},
                {name : 'PHP', count : 100},
                {name : 'Jquery', count : 100},
                {name : 'VueJS', count : 90},
                {name : 'Bootstrap', count : 90},
                {name : 'Firebase', count : 70},
            ],
            started : false,
            options: {
                color: '#007AFF',
                strokeWidth: 0.5
            }
        }),
        components : {
            countTo,
        },
        methods: {
            startCounts () {
                
                if (this.started) {
                    return;
                }
                
                for (let element in this.$refs) {
                    if (element != 'skillContainer') {
                        let temp =this.$refs[element][0]
                        temp.start()
                    }
                    
                }
              
            }
        },
        watch: {
            scrolling () {

                const emissionYOfsset = this.$refs.skillContainer.offsetTop

                if (window.scrollY + window.innerHeight >= emissionYOfsset &&
                    window.scrollY <= emissionYOfsset) {
                    this.startCounts()
                    this.started = true
                }
            }
        },
    }
</script>

<style scoped lang="">
.skill{
    border: 5px #401b85 solid;
    border-radius: 50%;
    height: 190px;
    width: 190px;
    display: flex;  
    justify-content: center;
    align-items: center;  
}
.level-center{
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/componests/Skills.vue